export default "__VITE_ASSET__DFVUEfRM__"